<harp-skip-nav></harp-skip-nav>
<harp-spinner></harp-spinner>
<harp-header *ngIf="currentApp.hasHeader"></harp-header>

<div
  class="harp-login-page"
  id="main"
  role="main"
  tabindex="-1"
  [class.harp-custom-bg]="currentApp.hasCustomBg"
>
  <div class="harp-login-page-header">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 offset-lg-3">
          <div class="text-center">
            <img
              class="harp-logo"
              src="{{ currentApp.adoLogo }}"
              alt="{{ currentApp.adoLogoAlt }}"
            />
            <p class="harp-page-subtitle">{{ currentApp.adoName }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="harp-login-page-content">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 offset-lg-3">
          <div class="card harp-login-card harp-material">
            <div class="card-body">
              <app-alert></app-alert>
              <router-outlet></router-outlet>
              <span *ngIf="currentApp.hasPrivacyPolicy">
                <hr />
                <a routerLink="/login/privacy-policy">Privacy Policy</a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="currentApp?.hasHarpResources" class="harp-featured-links">
  <ul class="list-group">
    <a
      href="https://www.youtube.com/playlist?list=PLaV7m2-zFKphoCXj7sIx2G1fwMZQQ0EJP"
      target="_blank"
    >
      <li class="list-group-item">
        <span class="icon ion-logo-youtube me-1"></span> Training Videos
        <span class="visually-hidden">opens in new tab</span>
      </li>
    </a>
    <a [routerLink]="['/help']" target="_blank">
      <li class="list-group-item">
        <span class="icon ion-md-help-circle me-1"></span> Help
        <span class="visually-hidden">opens in new tab</span>
      </li>
    </a>
  </ul>
</div>

<harp-footer *ngIf="currentApp.hasFooter"></harp-footer>
